import {IPresentation} from '../../incase-domain/presentation';
import {
    ADVANCE_SEQUENCE_STEP,
    IAdvanceSequenceStep,
    IJumpToSlide,
    IJumpToSlideWithId,
    IPreventClickToNextSlide,
    IResetPresentationReducer,
    IResetSequenceQueue,
    ISetActiveMobileQuestion,
    ISetSequenceQueue,
    IStartUploadedPresentation,
    IUpdateArrowsDisabledAction,
    IUpdatePresentationLoadingSlides,
    IUpdateScaleAction,
    JUMP_TO_SLIDE,
    JUMP_TO_SLIDE_WITH_ID,
    RESET_PRESENTATION_REDUCER,
    RESET_SEQUENCE_QUEUE,
    SCROLL_LEFT,
    SCROLL_RIGHT,
    SET_ACTIVE_MOBILE_QUESTION,
    SET_PREVENT_CLICK_TO_NEXT_SLIDE,
    SET_SEQUENCE_QUEUE,
    START_UPLOADED_PRESENTATION,
    UPDATE_ARROWS_DISABLED,
    UPDATE_CURRENT_SLIDE,
    UPDATE_LAST_SHOWED_SLIDE,
    UPDATE_LOADING_SLIDES,
    UPDATE_SCALE,
} from './types/presentation.actions.types';
import {
    IScrollLeftAction,
    IScrollRightAction,
    IUpdateCurrentSlide,
    IUpdateLastShowedSlide,
} from '../reducer/types/presentation.reducer.types';

export const setActiveMobileQestionAction = (id = ''): ISetActiveMobileQuestion => ({
    type: SET_ACTIVE_MOBILE_QUESTION,
    payload: id,
});

/* export const updatePresentationPreviewsAction = (previews: ISlidePreview[]): IUpdatePresentationPreviewsAction => ({
     type: UPDATE_PRESENTATION_PREVIEWS,
     payload: previews,
 });

export const fetchPresentationPreviewsAction = (): IFetchPresentationPreviewsAction => ({
    type: FETCH_PRESENTATION_PREVIEWS,
}); */

export const resetPresentationReducerAction = (): IResetPresentationReducer => ({
    type: RESET_PRESENTATION_REDUCER,
});

export const scrollLeftAction = (): IScrollLeftAction => ({
    type: SCROLL_LEFT,
});

export const scrollRightAction = (): IScrollRightAction => ({
    type: SCROLL_RIGHT,
});

export const updateCurrentSlide = (newSlideIndex: number): IUpdateCurrentSlide => ({
    type: UPDATE_CURRENT_SLIDE,
    payload: newSlideIndex,
});

export const updateLastShowedSlide = (newSlideIndex: number): IUpdateLastShowedSlide => ({
    type: UPDATE_LAST_SHOWED_SLIDE,
    payload: newSlideIndex,
});

export const startUploadedPresentationAction = (presentation: IPresentation): IStartUploadedPresentation => ({
    type: START_UPLOADED_PRESENTATION,
    payload: presentation,
});

export const jumpToSlideWithIdAction = (slideId: string, overrideBlockers?: boolean): IJumpToSlideWithId => ({
    type: JUMP_TO_SLIDE_WITH_ID,
    payload: {slideId, overrideBlockers},
});

export const jumpToSlideAction = (index: number, overrideBlockers?: boolean): IJumpToSlide => ({
    type: JUMP_TO_SLIDE,
    payload: {index, overrideBlockers},
});

export const updatePresentationLoadingSlides = (isLoading: boolean): IUpdatePresentationLoadingSlides => ({
    type: UPDATE_LOADING_SLIDES,
    payload: isLoading,
});

export const updateScale = (scale: number): IUpdateScaleAction => ({
    type: UPDATE_SCALE,
    payload: scale,
});

export const updateArrowsDisabledAction = (arrowsDisabled: boolean): IUpdateArrowsDisabledAction => ({
    type: UPDATE_ARROWS_DISABLED,
    payload: arrowsDisabled,
});

export const setPreventClickToNextSlide = (prevent: boolean): IPreventClickToNextSlide => ({
    type: SET_PREVENT_CLICK_TO_NEXT_SLIDE,
    payload: prevent,
});

export const advanceSequenceStepAction = (): IAdvanceSequenceStep => ({
    type: ADVANCE_SEQUENCE_STEP,
});

export const resetSequenceQueueAction = (): IResetSequenceQueue => ({
    type: RESET_SEQUENCE_QUEUE,
});

export const setSequenceQueueAction = (queue: Array<{elementId: string}>): ISetSequenceQueue => ({
    type: SET_SEQUENCE_QUEUE,
    payload: queue,
});
